
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SiteDataResponse } from "../../types";

type State = {
  siteData: SiteDataResponse | null;
};

const initialState: State = { siteData: null };

const siteDataSlice = createSlice({
  name: "siteData",
  initialState,
  reducers: {
    setSiteData(state: State, action: PayloadAction<SiteDataResponse>) {
      state.siteData = action.payload;
    },
    setLogout(state: State) {
      state.siteData = null;
    },
    
  },
});

export default siteDataSlice;

  